import React from 'react';
import { useTabsContext } from './TabsContext';
function TabCase({ children, value }) {
    const [tab] = useTabsContext();
    return React.createElement(React.Fragment, null, tab === value ? children : null);
}
export default TabCase;
//# sourceMappingURL=TabCase.js.map